import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './theme/theme.css';
import './index.css';
import { initTheme } from './lib/theme/theme';

// Apply the persisted / system theme before first paint (the inline script in
// index.html already did this to avoid flash; this re-syncs after hydration and
// wires the live prefers-color-scheme listener).
initTheme();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found');
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
